import { useState, useEffect } from 'react';

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date('2026-07-18T07:00:00-05:00');

    const updateTimer = () => {
      const now = new Date();
      const diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatNumber = (num: number) => num.toString().padStart(2, '0');

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-8 md:py-12">
      <div className="relative overflow-hidden rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-12 bg-gradient-to-br from-secondary-950 via-secondary-900 to-primary-800 text-white shadow-xl">
        {/* Brillos decorativos */}
        <div className="pointer-events-none absolute -top-20 -right-20 w-72 h-72 rounded-full bg-primary-500/30 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-accent-500/20 blur-3xl" />

        <div className="relative flex flex-col lg:flex-row items-center justify-between gap-6 mb-8 md:mb-10">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-3">
              <div className="w-8 h-0.5 bg-primary-400" />
              <p className="text-xs md:text-sm text-white/70 font-semibold tracking-widest uppercase">
                Presentado por ATEC
              </p>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-wide">
              CUENTA REGRESIVA PARA
            </h2>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-400 tracking-wide mb-3">
              BAÑOS RUN 2026
            </h2>
            <p className="text-base md:text-lg font-semibold">Sábado 18 de julio de 2026 · 07h00</p>
            <p className="text-sm text-white/60 mt-1">
              Parque Montalvo, Baños. Revisa el tiempo restante y organiza tu entrenamiento.
            </p>
          </div>

          <div className="flex-shrink-0 bg-white rounded-2xl p-3 shadow-lg">
            <img
              src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png"
              alt="Logo Baños Run 2026"
              className="w-40 md:w-48 h-auto object-contain"
            />
          </div>
        </div>

        {/* Countdown timer */}
        <div className="relative grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {[
            { label: 'DÍAS', value: timeLeft.days },
            { label: 'HORAS', value: timeLeft.hours },
            { label: 'MINUTOS', value: timeLeft.minutes },
            { label: 'SEGUNDOS', value: timeLeft.seconds },
          ].map((item, idx) => (
            <div
              key={idx}
              className="rounded-2xl p-4 md:p-6 text-center bg-white/10 backdrop-blur-sm ring-1 ring-white/20"
            >
              <p className="font-heading text-5xl md:text-6xl lg:text-7xl text-white tracking-wide tabular-nums leading-none">
                {formatNumber(item.value)}
              </p>
              <p className="text-[11px] md:text-sm text-primary-300 font-semibold tracking-[0.2em] mt-2">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}